import React from 'react';
import Grid from '@mui/material/Grid';

export default function BodyContainer({ children }) {
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      style={{ width: '100%', margin: 'auto' }}
    >
      {children}
    </Grid>
  );
}
